<template>
  <div class="panel">
    <div class="panel-content">
      <div class="panel-title">
        Cercador portal ReusOpenData
      </div>
      <q-input
        ref="search_input"
        class="search-bar"
        v-model="q"
        autofocus
        square
        outlined
        hide-bottom-space
        bg-color="white"
        :placeholder="t('search') | capitalize"
        @keyup.enter="onSearch"
      >
        <template v-slot:append>
          <q-btn
            flat
            class="full-height"
            icon="search"
            @click="onSearch"
          />
        </template>
      </q-input>
      <p v-if="!q && !results" class="q-py-md">Si us plau, escriviu quelcom per cercar al portal de dades obertes ReusOpenData</p>
      <div v-if="query" class="q-pt-md">
        <p class="panel-title">{{ t('results', { q: query }) }} <q-spinner v-if="loading"/></p>
        <div v-if="!loading">
          <div v-if="results && results.length > 0">
            <q-list separator>
              <list-item
                v-for="result in results"
                v-bind:key="result.id"
                :result="result"
              />
            </q-list>
          </div>
          <div v-else-if="hasErrors">
            {{ t('resultsError') }}
          </div>
          <div v-else class="list-group-item">
            {{ t('noResults') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QBtn, QInput, QList, QSpinner } from 'quasar'
import { mapState } from 'vuex'

import ListItem from 'components/OpenDataListItem.vue'

export default {
  components: {
    ListItem,
    QBtn,
    QInput,
    QList,
    QSpinner
  },
  data () {
    return {
      q: this.query
    }
  },
  computed: {
    ...mapState({
      hasErrors: state => state.openData.errorFetching,
      loading: state => state.openData.loading,
      query: state => state.openData.query,
      results: state => state.openData.results
    })
  },
  methods: {
    t (key, ...args) {
      return this.$t('tools.search.' + key, ...args)
    },
    onSearch () {
      if (this.q) {
        this.$store.commit('openData/query', this.q)
        this.$store.dispatch('openData/searchDataset')
      }
    }
  }
}
</script>

<style>
.search-bar .q-field__control {
  padding-right: 0;
}
</style>
